import { render, staticRenderFns } from "./Wxapp.vue?vue&type=template&id=04683106&"
import script from "./Wxapp.vue?vue&type=script&lang=js&"
export * from "./Wxapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports